import { Button, makeStyles, TextField, Typography, CircularProgress } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { postRequest } from '../Helpers/RequestHelper';

const ForgotPasswordRequestPage = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    useEffect(() => {
        document.title = 'Oxford Lymphoedema Practice - Forgot Password';
    })

    const useStyles = makeStyles(theme => ({
        page: {
            paddingTop: 20,
            width: '80%',
            margin: 'auto'
        },
        formSection: {
            width: '100%',
            margin: '20px auto',
            position: 'relative'
        },
        buttonProgress: {
            color: 'white',
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12,
        },
        root: {
            '&$disabled': {
                backgroundColor: theme.palette.primary.light,
                color: 'white'
            },
        },
        disabled: {}
    }));

    const classes = useStyles();

    const forgottenSubmitPressed = (e) => {
        e.preventDefault();
        setLoading(true);
        setSuccess('');
        setError('');
        var passChangeRequest = {
            fieldData: {
                Message: "Changing password"
            },
            script: "RequestPasswordChange",
            "script.param": JSON.stringify({ username: email })
        };

        postRequest(passChangeRequest)
            .then(function (result) {
                setLoading(false);
                setSuccess('If this email address is registered with us, we will send you a reset email. Please check your junk folder.');
            })
            .catch(function (error) {
                setLoading(false);
            });
    }

    const backButtonPressed = () => {
        history.replace('/login');
    };


    return (
        <div className={classes.page}>
            <form onSubmit={forgottenSubmitPressed}>
                <div className={classes.formSection}>
                    <TextField style={{ width: '100%', backgroundColor: 'white', borderRadius: 5 }} variant='outlined' id='email' label='Email address' value={email} onChange={(e) => setEmail(e.currentTarget.value)} />
                </div>
                <div className={classes.formSection}>
                    {success !== "" && <Typography style={{ color: 'black' }}>{success}</Typography>}
                </div>
                <div className={classes.formSection}>
                    {success === "" && <Button type="submit" style={{ width: '100%', height: 60 }} variant="contained" color="primary" disabled={loading} classes={{ disabled: classes.disabled, root: classes.root }}>
                        Submit
                    </Button>}
                    {success !== "" && <Button style={{ width: '100%', height: 60 }} variant="contained" color="primary" onClick={backButtonPressed}>
                        Back to login
                    </Button>}
                    {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </div>
            </form>
        </div>
    );
}

export default ForgotPasswordRequestPage;